var o={UNKNOWN:0,MARTY:1,KRATOS:2};var t="session-id",r="x-main",s="zfc";

export { t as SESSION_ID, o as WEB_VITAL_APPS, r as X_MAIN, s as ZFC_SESSION };
